
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("lRTsu", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $494d7424a04e3551$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Chinese (Traditional)
var $494d7424a04e3551$export$2e2bcd8739ae039 = {
    'fabric.elements.mentions.team.member.50plus': "\u5718\u968A \u2022 50 \u540D\u4EE5\u4E0A\u7684\u6210\u54E1",
    'fabric.elements.mentions.team.member.50plus.including.you': "\u5718\u968A \u2022 50 \u540D\u4EE5\u4E0A\u7684\u6210\u54E1\uFF0C\u5305\u542B\u60A8",
    'fabric.elements.mentions.team.member.count': "{0, plural, other {\u5718\u968A \u2022 {0} \u540D\u6210\u54E1}}",
    'fabric.elements.mentions.team.member.count.including.you': "{0, plural, other {\u5718\u968A \u2022 {0} \u540D\u6210\u54E1\uFF0C\u5305\u542B\u60A8}}",
    'fabric.elements.mentions.xproduct.mention.description': "\u9700\u8981 Confluence \u7684\u5B58\u53D6\u6B0A",
    'fabric.mention.error.defaultAction': "\u5E7E\u79D2\u5F8C\u518D\u8A66\u4E00\u6B21",
    'fabric.mention.error.defaultHeadline': "\u767C\u751F\u554F\u984C",
    'fabric.mention.error.differentText': "\u5617\u8A66\u8F38\u5165\u4E0D\u540C\u7684\u6587\u5B57",
    'fabric.mention.error.loginAgain': "\u5617\u8A66\u767B\u51FA\uFF0C\u7136\u5F8C\u518D\u767B\u5165",
    'fabric.mention.noAccess.label': "\u7121\u5B58\u53D6\u6B0A",
    'fabric.mention.noAccess.warning': "{name} \u6C92\u6709\u5B58\u53D6\u6B0A\uFF0C\u56E0\u6B64\u4E0D\u6703\u6536\u5230\u901A\u77E5",
    'fabric.mention.unknow.user.error': "\u672A\u77E5\u7684\u4F7F\u7528\u8005 {userId}"
};

});


//# sourceMappingURL=zh_TW.018b8e11.js.map
